<template>
  <div class="fireBook">
    <div class="smokeAlarmAuto">
      <div style="text-align: center;margin-bottom:30px;"><img src="~@/assets/img/smoke_e.png" alt=""></div>
      <div style="text-align: center;">
        <!-- <img src="~@/assets/img/smoke_f.png" alt="">
        <img src="~@/assets/img/twoLight.png" alt="" style="margin:0 77px;">
        <img src="~@/assets/img/threeLight.png" alt=""> -->
      </div>
    </div>
    <div class="fireBookBox j-fire-box">
      <el-tabs v-model="activeName" @tab-click="handleTabClick" :stretch="tabsStretch">
        <el-tab-pane name="first" v-if="!onlyShowSecond">
          <template slot="label">
            <img src="~@/assets/img/fireDoc.png" style="vertical-align: middle;" alt="">
          </template>
          <div class="police" style="padding-left:64px;">
            <el-timeline>
              <el-timeline-item placement="top"
                                v-for="(item, index) in timelines"
                                :key="index"
                                :timestamp="item.createAt">
                <div class="fireText" v-if="item.reportType == 1">     <!-- 普通信息 -->
                  <el-row :gutter="20" class="j-file-book">
                    <el-col :span="4"><span>{{ item.createTime }}</span></el-col>
                    <el-col :span="20"><span>{{ item.deptName }}</span></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24"><span>{{ item.msg }}</span></el-col>
                  </el-row>
                </div>
                <div class="fireText" v-if="item.reportType == 2 && item.imgList && item.imgList.length > 0">
                  <el-col :span="8"><span>{{ item.createTime }}</span></el-col>
                  <el-col :span="10">
                    <el-image :src="imgItem" v-for="(imgItem,ydex) in item.imgList" :key="ydex" style="width: 160px; height: 90px"></el-image>
                  </el-col>
                  <el-col :span="6"><span>{{ item.deptName }}</span></el-col>
                </div>
                <div class="fireText" v-if="item.reportType == 2 && item.video">
                  <el-col :span="8"><span>{{ item.createTime }}</span></el-col>
                  <el-col :span="10"><span>
                    <video autoplay="muted" width="50%" preload="auto" controls="controls" :src="item.video"
                           type="video/mp4"
                           height="150px">
                    </video>
                    </span></el-col>
                  <el-col :span="6"><span>{{ item.deptName }}</span></el-col>
                </div>
                <div class="fireText" v-if="item.reportType == 5">
                  <h4>{{ item.location }}</h4>
                  <gaodemap :lng="item.longitude" :lat="item.dimensionality"></gaodemap>
                </div>
              </el-timeline-item>
            </el-timeline>
          </div>
          <div class="policeInfo j-police" style="padding-top:10px;border-top:1px solid #fff;">
            <el-form
              ref="form"
              v-model="form"
              :inline="true"
              class="demo-form-inline"
              v-if="canOper"
              label-width="100px">
              <el-row :gutter="32">
                <el-col :span="18">
                  <el-form-item label="调度内容:">
                    <el-input v-model="form.msg" type="textarea" :rows="4" style="width:calc(25vw);"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item>
                    <span>
                      <img src="~@/assets/img/reply.png" alt @click="sendMessage"/>
                    </span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-upload
                class="upload-demo"
                action
                multiple
                style="margin-left:100px;color:#EDEC70;"
                :http-request="uploadHttp"
                :file-list="fileList"
              >
                <el-button size="small" type="text" style="color: #EDEC70">图片/视频</el-button>
              </el-upload>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane name="second">
          <template slot="label">
            <img src="~@/assets/img/taskDet.png" style="vertical-align: middle;" alt="">
          </template>
          <div class="taskDetail">
            <el-form label-width="120px" label-position="right">
              <el-form-item label="警情编码："><span>{{ alarmsing.queryFireBook.alarmSingle.number }}</span></el-form-item>
              <el-form-item label="持续时间："><span>{{ alarmsing.queryFireBook.alarmSingle.closingacaseTime }}</span>
              </el-form-item>
              <!-- <el-form-item label="出动单位："><span>{{ selectRow.queryFireBook.deptDO.name }}</span></el-form-item> -->
              <el-form-item label="报警时间："><span>{{ alarmsing.queryFireBook.alarmSingle.alarmTime }}</span>
              </el-form-item>
              <el-form-item label="设备位置："><span>{{ alarmsing.queryFireBook.alarmSingle.disasterAddress }}</span>
              </el-form-item>
              <el-form-item label="接警时间："><span>{{ alarmsing.queryFireBook.alarmSingle.reportTime }}</span>
              </el-form-item>
              <el-form-item label="是否电话处置：">
                <span v-if="alarmsing.queryFireBook.alarmSingle.disposeState == '1'">是</span>
                <span v-if="alarmsing.queryFireBook.alarmSingle.disposeState != '1'">否</span>
              </el-form-item>
              <el-form-item label="现场到达时间："><span>{{ alarmsing.queryFireBook.alarmSingle.arrivalTime }}</span>
              </el-form-item>
              <el-form-item label="完成报告时间："><span>{{ alarmsing.queryFireBook.alarmSingle.closingTime }}</span>
              </el-form-item>
              <el-form-item label="战斗员人数："><span>{{ alarmsing.queryFireBook.alarmSingle.participateNumber }}</span>
              </el-form-item>
              <el-form-item label="出动装备数量："><span>{{ alarmsing.queryFireBook.alarmSingle.equipmentNumber }}</span>
              </el-form-item>
              <el-row :gutter="32" v-if="canOper" style="text-align:center;">
                <el-col :span="24">
                  <!-- 提交总结报告 -->
                  <!-- <img src="~@/assets/img/subRep.png" @click="submitReport" alt="" v-if="subRep"> -->
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane name="three" v-if="!onlyShowSecond">
          <template slot="label">
            <img src="~@/assets/img/warPer.png" style="vertical-align: middle;" alt="">
          </template>
          <el-table :data="taskUserList" style="background:transparent;" class="policeOutNum">
            <el-table-column label="" prop="msg">
            </el-table-column>
            <el-table-column label="" prop="name">
            </el-table-column>
            <el-table-column label="" prop="phone">
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>


    <el-dialog class="fireDoc" :visible.sync="dialog.handAlarmVisible" width="30%" title="出动总结" append-to-body center show-close>
      <el-input type="textarea" placeholder="请输入" v-model="content" maxlength="30" rows="10"
                show-word-limit></el-input>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button type="primary" size="small" @click="auditInfo">审核</el-button> -->
        <span>
                    <el-button
                      @click="auditInfo()"
                      style="
          width: 206px;
          height: 43px;
          background: #0080db;
          border-radius: 22px;
        " round
                      type="primary"
                    ><label style="font-size: 18px; font-weight: bold; color: #ffffff">
          提交
        </label></el-button>

         </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import gaodemap from '@/pages/gaodemap/gaodemap'

export default {
  name: 'fireBook',
  components: {
    gaodemap
  },
  props: [
    'selectRow',
    'dataFinish',
  ],
  data() {
    return {
      alarmsing: {},
      activeName: 'first',
      timelines: [],
      form: {msg: ''},
      fileList: [],
      fileListVideo: [],
      taskUserList: [],
      content: '',
      tabsStretch: true,
      dialog: {
        handAlarmVisible: false,
      },
      content: '',
      photoFormData: [],
      videoFormData: {},
      fileFormData: {},
      canOper: this.$store.state.canOper,
      onlyShowSecond: this.$store.state.onlyShowSecond,
      submitBtn: 0,
      subRep: this.$store.state.subRep,
      process: {
        name: ''
      }
    }
  },
  watch: {
    '$store.state.selectFireBookActive'() {
      if (this.$store.state.selectFireBookActive !== this.activeName) {
        this.activeName = this.$store.state.selectFireBookActive;
      }
    }
  },
  created() {
    let _this = this;
    this.activeName = this.$store.state.selectFireBookActive;
    if(!_this.dataFinish){
      _this.queryFireDoucment();
      _this.queryFireBook()
      _this.timer = setInterval(() => (_this.queryFireDoucment(),_this.queryFireBook()), 5000);
    }else{
      _this.queryFireDoucment();
      _this.queryFireBook()
    }

  },
  mounted() {
    let _this = this;
    _this.fileFormData = new FormData();
  },
  methods: {
    queryFireBook() {//查询火场文书
      let _this = this;
      var success = function (resp) {
        _this.alarmsing.queryFireBook = resp;
        _this.alarmsing.audit = '1';
        _this.alarmsing.idStr = _this.idStr;
        let timeAction = "";
        timeAction = resp.alarmSingle.closingacaseTime;
        if (resp.alarmSingle.closingacaseState == '0' || resp.alarmSingle.closingacaseState == '3') {
          _this.duractionTime(resp.alarmSingle.closingacaseTime);
        }
      }
      _this.http.get('/webapi/probe/qureyvide/' + this.selectRow.id, {}, success);
    },
    duractionTime(timeAction) {
      let _this = this;
      if (timeAction != null) {
        _this.alarmsing.queryFireBook.alarmSingle.closingacaseTime = timeAction;
      } else {
        let timestamp = new Date().getTime();
        let oldTime = new Date(
          _this.alarmsing.queryFireBook.alarmSingle.alarmTime
        ).getTime(); //得到毫秒数
        let total = (timestamp - oldTime) / 1000;
        let day = parseInt(total / (24 * 60 * 60)); //计算整数天数
        let afterDay = total - day * 24 * 60 * 60; //取得算出天数后剩余的秒数
        let hour = parseInt(afterDay / (60 * 60)); //计算整数小时数
        let afterHour = total - day * 24 * 60 * 60 - hour * 60 * 60; //取得算出小时数后剩余的秒数
        let min = parseInt(afterHour / 60); //计算整数分
        let afterMin = parseInt(total - day * 24 * 60 * 60 - hour * 60 * 60 - min * 60); //取得算出分后剩余的秒数
        let seconds = Math.round(afterMin / 1000);
        _this.timeAll =
          day + "天 " + hour + "小时 " + min + " 分钟" + afterMin + " 秒";
        _this.alarmsing.queryFireBook.alarmSingle.closingacaseTime = _this.timeAll;
      }
    },
    getMap() {
    },
    submitReport() {//提交总结报告
      let _this = this;
      _this.dialog.handAlarmVisible = true;
    },
    auditInfo() {
      let _this = this;
      _this.dialog.handAlarmVisible = false;
      if (!_this.content) {
        _this.$message.warning("请输入审核内容");
        return;
      }
      var data = {
        content: _this.content,
        id: this.selectRow.id
      }
      var success = function (resp) {
        if (resp.code === '0') {
          _this.dialog.handAlarmVisible = false;
          _this.$emit("closeSmokeAlarm");
          _this.$message.success("提交成功！");
          _this.dialog.handAlarmVisible = false;
          
        } else {
          _this.$message.error('提交失败！');
        }
      }

      _this.http.post('/webapi/writ/submitAudit', data, success);

    },
    stopBellRing(idStr) {
      let _this = this;
      var data = {
        "msgId": idStr
      }
      var success = function (resp) {
      }
      _this.http.post('/wxf/msg/readMsg', data, success);
    },
    openAuditInfo() {
      let _this = this;
      _this.handAlarmVisible = true;
    },
    uploadHttp(param) {
      let _this = this;
      var fileType = param.file.type.split("/")[0];
      if (fileType === 'image') {//图片
        _this.fileFormData.append('filePath', param.file);
      } else if (fileType === 'video') {//视频
        _this.fileFormData.append('videoPath', param.file);
      } else {
        _this.$message.warning('格式不正确');
      }
    },
    callPerson(phone) {
      let _this = this;
      let success = function (resp) {
        if (resp.code === '0') {
          _this.$message.success(resp.msg);
        }
      }
      _this.http.post('/webapi/writ/voiceCalls', {phone: phone}, success);
    },
    sendMessage() {
      let _this = this;
      _this.fileFormData.append('taskId', _this.selectRow.id);
      _this.fileFormData.append('msg', _this.form.msg);
      let success = function (resp) {
        if (resp.code === '0') {
          _this.$message.success(resp.msg);
          _this.form.msg = "";
          _this.fileList = [];
          _this.fileFormData = new FormData();
        } else {
          _this.$message.error(resp.msg);
        }
      }
      _this.http.postFile('/webapi/writ/taskReportSave', _this.fileFormData, success);
    },
    handleTabClick(tab, event) {
      let _this = this;
      if (tab.name === 'first') {//火场文书
        _this.$store.commit('updateSelectFireBookActive', 'first');
        _this.queryFireDoucment();
      } else if (tab.name === 'second') {//任务详情
        _this.queryFireDoucment();
        _this.$store.commit('updateSelectFireBookActive', 'second');
      } else if (tab.name === 'three') {//战斗组成员
        _this.$store.commit('updateSelectFireBookActive', 'three');
        _this.queryTaskUserList();
      }
    },
    queryTaskUserList() {
      console.log('到了')
      let _this = this;
      let success = function (resp) {
        _this.taskUserList = resp;
      }
      _this.http.get('/webapi/writ/taskUserList', {taskId: _this.selectRow.id}, success);
    },
    queryFireDoucment() {//查询火场文书内容
      let _this = this;
      let success = function (resp) {
        _this.timelines = resp.data;
      }
      _this.http.get('/webapi/writ/taskReport/' + _this.selectRow.id, {}, success);
    }
  },
  destroyed(){
    let _this = this;
    clearInterval(_this.timer);

  }
}
</script>

<style lang="less">

.fireBook {
  .el-main {
    height: calc(50vh);
  }

  .policeOutNum {

  }

  .el-table tr td:nth-child(1) {
    color: #fff !important;
  }

  .el-table tr th {
    display: none;
  }

  .el-table tr td, .el-table tr th {
    color: #B4B4B4 !important;
    border-bottom: 0px;
    background: #3b3b3b !important;
  }

  .el-tabs__nav-wrap {
    border-radius: 16px;
    // background-color: white !important;
    -webkit-box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.7);
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.7);
  }

  .el-dialog__title {
    color: #fff;
    line-height: 30px;
    text-shadow: 1px 2px 10px rgba(4, 0, 0, 0.7);
  }

  .fireBookBox {
    .el-tabs__header {
      margin: 0px;
      border: 1px solid #fff;
    }

    .police, .taskDetail, .policeOutNum {
      border: 1px solid #fff;
      border-top: 0px;
    }

    border-radius: 16px;

    .el-tabs__active-bar {
      height: 7px;
      background: #EBEB6C;
      border-radius: 4px;
    }

    .el-tabs__nav {
      line-height: 64px;
      height: 64px;
      padding-top: 15px;
    }

    .taskDetail {
      color: #fff;

      .el-form-item__label {
        color: #fff;
      }
    }

    .fireDoc {
      .el-dialog__header {
        background-color: #0080DB;

        .el-dialog__title {
          color: rgb(247, 247, 247);
        }
      }
    }
  }
}

.j-police {
  margin: 10px auto 0px;
  width: auto;
  border-radius: 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/fireBook/fireBook.vue